module.exports = __webpack_public_path__ + "static/media/aviva.54da3a04.svg";